import Vue from "vue";
import VueCustomElement from 'vue-custom-element';
//import KeyboardShortcuts from './components/shortcuts/keyboard-shortcuts.vue';
import Loader from "./components/utility/CodigoLoader.vue";
import Footer from "./components/footer/CodigoFooter.vue";
import PageTitle from "./components/utility/CodigoPageTitle.vue";
import SaveButton from "./components/utility/CodigoSaveButton.vue";
import KioskReports from "./components/reports/kioskReports.vue";
import BootstrapVue from 'bootstrap-vue';
import JsonExcel from 'vue-json-excel';
export const eventBus = new Vue();
Vue.use(BootstrapVue);
Vue.use(VueCustomElement);
//Vue.customElement('keyboard-shortcuts', <ComponentOptions<Vue>>new KeyboardShortcuts().$options);
Vue.customElement('codigo-loader', new Loader().$options);
Vue.customElement('codigo-footer', new Footer().$options);
Vue.customElement('codigo-page-title', new PageTitle().$options);
Vue.customElement('codigo-save-button', new SaveButton().$options);
Vue.customElement('kiosk-reports', new KioskReports().$options);
Vue.component('downloadExcel', JsonExcel);
